<template>
  <b-row>
    <b-col>
        <div class="text-right">
          <button type="button"
                  class="btn btn-sm fa fa-sync fa-lg btn-link"
                  @click="clearFilters">
          </button>
          <b-button class="btn-sm ml-2" v-b-tooltip.hover :title="$t('buttons.search')"
                    v-b-toggle.userdata_search_collapse variant="primary"><i class="fa fa-filter"></i></b-button>
        </div>
        <div>
          <b-collapse id="userdata_search_collapse" class="mt-2">
            <CorrespondenceThreadsFiltering :idContractor="idContractor" @getPage="filterData" ref="correspondenceThreadsFiltering"></CorrespondenceThreadsFiltering>
          </b-collapse>
        </div>
        <Loader v-if="isLoading"></Loader>
        <span v-else-if="!isLoading && items.length < 1">{{ $t('views.excmcorrespondence.list.noItems') }}</span>
        <table v-else class="table table-sm table-striped table-hover">
          <thead>
          <tr>
            <th>
                <span @click="changeOrder('messageDateTime')" class="th-link">
                  {{$t('views.excmcorrespondence.list.messageDateTime')}}
                </span>
              <i v-if="order['messageDateTime']" :class="{'fas fa-sort-down': order['messageDateTime'] === 'desc', 'fas fa-sort-up': order['messageDateTime'] === 'asc'}"></i>
            </th>
            <th>{{$t('views.excmcorrespondence.list.idContractor')}}</th>
            <th>{{$t('views.excmcorrespondence.list.emails')}}</th>
            <th>{{$t('views.excmcorrespondence.list.subject')}}</th>
            <th>
                <span @click="changeOrder('messagesQuantity')" class="th-link">
                  {{$t('views.excmcorrespondence.list.messageQuantity')}}
                </span>
              <i v-if="order['messagesQuantity']" :class="{'fas fa-sort-down': order['messagesQuantity'] === 'desc', 'fas fa-sort-up': order['messagesQuantity'] === 'asc'}"></i>
            </th>
            <th>
                <span @click="changeOrder('lastMessage.messageDateTime')" class="th-link">
                  {{$t('views.excmcorrespondence.list.lastMessageDate')}}
                </span>
              <i v-if="order['lastMessage.messageDateTime']" :class="{'fas fa-sort-down': order['lastMessage.messageDateTime'] === 'desc', 'fas fa-sort-up': order['lastMessage.messageDateTime'] === 'asc'}"></i>
            </th>
            <th v-if="ableToShowCase">{{$t('views.excmcorrespondence.list.relatedCases')}}</th>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="item in items"
            :key="item['@id']">
            <td>
              <span v-if="item.messageDateTime">{{ $moment(item.messageDateTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
            </td>
            <td>
              <router-link v-if="item.idContractor && item.idContractor.isCompany === 0" :to="{name: 'UserDataShow', params: { id: item.idContractor['@id'] }}">
                {{ item.idContractor.name }} {{ item.idContractor.surname }}
              </router-link>
              <router-link v-else-if="item.idContractor" :to="{name: 'FirmShow', params: { id: item.idContractor['@id'] }}">
                {{ item.idContractor.firmname1 === '' ? item.idContractor.fullName : item.idContractor.firmname1 }}
              </router-link>
            </td>
            <td>
              <p class="p-0 m-0" v-for="(email, emailIndex) in getEmailsInThread(item)" :key="'emailIndex' + emailIndex">
                <a :href="'mailto: ' + email">{{email}}</a>
              </p>
            </td>
            <td>
              <router-link :to="{name: 'EXCMCorrespondenceThreadShow', params: { id: item['@id'] }}">
                {{ item.subject }}
              </router-link>
            </td>
            <td>{{ item.messages.length }}</td>
            <td v-if="item.messages.length > 0">{{ $moment(item.messages[item.messages.length - 1].messageDateTime).format('YYYY-MM-DD HH:mm:ss') }}</td>
            <td v-if="ableToShowCase">
              <span v-for="(messageCase, messageCaseIndex) in getRelatedCases(item)" :key="'messageCaseIndex' + messageCaseIndex">
                <span v-if="messageCaseIndex > 0">, </span>
                <router-link :to="{name: 'EXCMCaseShow', params: { id: messageCase['@id'] }}">
                  <span v-if="messageCase.number">{{ messageCase.number }}</span>
                  <span v-else>{{ getIdLink(messageCase['@id']) }}</span>
                </router-link>
              </span>
            </td>
            <td>
              <b-dropdown
                class="float-left"
                size="sm" variant="link"
                right text="Right align"
                toggle-class="text-decoration-none" no-caret>
                <template #button-content>
                  <i class="fa fa-bars fa-lg"></i>
                </template>
                <b-dropdown-item
                  @click="showSetContractorModal(item)">
                  <i class="fa fa-edit fa-lg"></i>
                  {{ $t('views.excmcorrespondence.list.setContractor') }}
                </b-dropdown-item>
              </b-dropdown>
            </td>
          </tr>
          </tbody>
        </table>
        <pagination
          v-if="view"
          :view="view"
          @getPage="getPage"
        ></pagination>
    </b-col>
    <updateCorrespondenceThreadRelatedUserDataModal v-if="updateCorrespondenceThread" :update-correspondence-thread="updateCorrespondenceThread" @reset="resetUpdateCorrespondenceThread($event)"/>
  </b-row>
</template>
<script>
import CorrespondenceThreadsFiltering from '@/components/Dashboard/Views/excmcorrespondence/components/CorrespondenceThreadsFiltering'
import Loader from '../../Layout/Loader'
import Pagination from '../../Layout/Pagination'
import { mapActions, mapGetters } from 'vuex'
import addParamsToQuery from '@/utils/addParamsToQuery'
import UpdateCorrespondenceThreadRelatedUserDataModal from '@/components/Dashboard/Views/excmcorrespondence/UpdateCorrespondenceThreadContractorModal'
import getId from '@/utils/getIdFromLink'
import { checkPermission } from '@/utils/checkRoles'

export default {
  name: 'CorrespondenceThreadsTable',
  components: { UpdateCorrespondenceThreadRelatedUserDataModal, CorrespondenceThreadsFiltering, Loader, Pagination },
  data () {
    return {
      searchParams: {
        itemsPerPage: 10,
        state: 1,
        idContractor: this.idContractor
      },
      orderReference: {},
      order: {
        'lastMessage.messageDateTime': '',
        'messageDateTime': '',
        'messagesQuantity': ''
      },
      updateCorrespondenceThread: null
    }
  },
  created () {
    this.orderReference = JSON.parse(JSON.stringify(this.order))
    let url = addParamsToQuery('e_x_c_m_correspondence_threads', this.searchParams)
    this.getPage(url)
  },
  methods: {
    ...mapActions({
      getPage: 'excmcorrespondence/list/default'
    }),
    changeOrder (property) {
      switch (this.order[property]) {
        case '':
          this.order[property] = 'asc'
          break
        case 'asc':
          this.order[property] = 'desc'
          break
        case 'desc':
          this.order[property] = ''
          break
      }
      this.filterData()
    },
    filterData (url = 'e_x_c_m_correspondence_threads') {
      let searchParams = {}
      Object.keys(this.order).forEach(property => {
        if (this.order[property]) {
          searchParams[`order[${property}]`] = this.order[property]
        } else {
          delete searchParams[`order[${property}]`]
        }
      })
      url = addParamsToQuery(url, searchParams)
      this.getPage(url)
    },
    clearFilters () {
      this.order = JSON.parse(JSON.stringify(this.orderReference))
      if (this.$refs.correspondenceThreadsFiltering) {
        this.$refs.correspondenceThreadsFiltering.clearFilters()
      }
    },
    resetUpdateCorrespondenceThread (withReload = false) {
      this.updateCorrespondenceThread = null
      if (withReload) {
        this.getPage(this.view['@id'])
      }
    },
    showSetContractorModal (item) {
      this.updateCorrespondenceThread = { '@id': item['@id'], idContractor: item.idContractor ? item.idContractor['@id'] : null }
    },
    getRelatedCases (item) {
      let relatedCases = []
      for (let i in item.messages) {
        for (let j in item.messages[i].relatedCases) {
          relatedCases.push(item.messages[i].relatedCases[j])
        }
      }
      return relatedCases
    },
    getEmailFromProperty (content) {
      if (content.includes('<') && content.includes('>')) {
        const start = content.indexOf('<') + 1
        const end = content.indexOf('>', start)
        return content.substring(start, end)
      }
      return content.trim()
    },
    getEmailsInThread (item) {
      let emails = []
      for (let i in item.messages) {
        if (item.messages[i].messageFrom) {
          emails.push(this.getEmailFromProperty(item.messages[i].messageFrom))
        }
        if (item.messages[i].messageTo) {
          emails.push(this.getEmailFromProperty(item.messages[i].messageTo))
        }
      }
      return [...new Set(emails)]
    },
    getIdLink (link) {
      return getId(link)
    }
  },
  computed: {
    ableToShowCase () {
      return checkPermission('cases', 'EXCMCaseShow')
    },
    ...mapGetters({
      deletedItem: 'excmcorrespondence/del/deleted',
      error: 'excmcorrespondence/list/error',
      items: 'excmcorrespondence/list/items',
      isLoading: 'excmcorrespondence/list/isLoading',
      view: 'excmcorrespondence/list/view'
    })
  },
  props: {
    idContractor: {
      type: String,
      default: ''
    }
  }
}
</script>
